import * as yup from 'yup';
import Axios from 'axios';
import Cookies from 'js-cookie';
import { getVideoIdYoutube } from '../../../utils/youtube';

function checkIfURL(str) {
  let url = false;
  try {
    if (str) {
      url = new URL(str);
    }
  } catch (e) {
    return url;
  }
  return url;
}

const Step2Module3Schema = yup.object().shape({
  videoUrl: yup
    .string()
    .notRequired()
    .when('$validateVideo', {
      is: false,
      then: yup
        .string()
        .notRequired()
        .transform((v, o) => '')
    })
    .test('matches', 'VideoId valido', function checkMatch(value) {
      const result = !value ? true : getVideoIdYoutube(value);
      return result;
    })
    .test('existInArray', 'Ya existe en el array', function arrCheck(value) {
      const arr = this.options.context.videos;
      if (value !== undefined) {
        const videoId = getVideoIdYoutube(value);
        if (videoId) {
          const findVideoUrl = arr.videos.find(e => e.key_video === videoId);
          return findVideoUrl === undefined;
        }
      }
      return true;
    }),
  video360: yup
    .string()
    .notRequired()
    .when('$validate360', {
      is: false,
      then: yup
        .string()
        .notRequired()
        .transform((v, o) => '')
    })
    .test('checkUrl', 'Url Valida', async function checkMatch(value) {
      if (value) {
        const parsedURL = checkIfURL(value);
        if (!parsedURL) {
          return Promise.resolve(false);
        }
        const url = `${process.env.REACT_APP_API_PUBLICADOR}/publicador/api/v1/multimedia/validatetour?url=${value}`;
        const headers = {
          'x-panel-portal': process.env.REACT_APP_BUILD_SITE,
          sessionId: Cookies.get('sessionId')
        };
        const result = await Axios.post(url, null, { headers: { ...headers } })
          .then(resp => resp.data.status === 200)
          .catch(() => false);
        return result;
      }
      return true;
    })
});

const step2Schema = yup.object().shape({
  pictures: yup
    .array()
    .min(5, 'publisher.step2.module1.picture.validation.min')
    .max(50, 'publisher.step2.module1.picture.validation.max')
    .required('publisher.step2.module1.picture.validation.min'),
  videos: yup
    .array()
    .max(10)
    .nullable()
    .notRequired(),
  tour360: yup
    .array()
    .max(1)
    .nullable()
    .notRequired(),
  plans: yup
    .array()
    .max(50, 'publisher.step2.module2.plans.validation.max')
    .nullable()
    .notRequired()
});

export { step2Schema, Step2Module3Schema };
